import React, { useEffect, useState, useRef } from 'react';
import { LoadScriptNext, Autocomplete } from "@react-google-maps/api";

const GOOGLE_MAPS_API_KEY = 'AIzaSyDwOFrgNmM51uT1F1zg_L0Em5ujW9obcHk';
const libraries = ["places"];

const LocationSearch = ({ onLocationSelect, currentAddress }) => {
    const [autocomplete, setAutocomplete] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null); // Ref to access input

    useEffect(() => {
        if (currentAddress) {
            setInputValue(currentAddress);
        }
    }, [currentAddress]);

    const onLoad = (autoC) => {
        setAutocomplete(autoC);
    };

    const handleFocus = () => {
        // Select all text when input is focused
        if (inputRef.current) {
            inputRef.current.select();
        }
    };

    const onPlaceChanged = () => {
        if (!autocomplete) return;
        const place = autocomplete.getPlace();
        if (place?.geometry) {
            const address = place.formatted_address || '';
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();
    
            // ✅ Update input value with selected address
            setInputValue(address);
    
            // Trigger parent callback
            onLocationSelect({ latitude, longitude, address });
            
            // Auto-reload the page after a brief delay to ensure all data is fetched with new location
            setTimeout(() => {
                window.location.reload();
            }, 250); // 250ms delay to allow data fetching to complete
        } else {
        }
    };
    

    const handleInputChange = (e) => setInputValue(e.target.value);

    return (
        <LoadScriptNext googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={libraries}>
            <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                <input
                    type="text"
                    ref={inputRef} // Assign the ref here
                    placeholder="Enter location..."
                    className="form-control"
                    value={inputValue}
                    onChange={handleInputChange}
                    onFocus={handleFocus}
                    onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} // Prevent form submit on enter
                />
            </Autocomplete>
        </LoadScriptNext>
    );
};

export default LocationSearch;


// import React, { useEffect, useState } from 'react';
// import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

// const LocationSearch = ({ onLocationSelect, currentAddress }) => {
//     const [value, setValue] = useState(null);

//     useEffect(() => {
//         if (currentAddress) {
//             setValue({ label: currentAddress, value: currentAddress });
//         }
//     }, [currentAddress]);

//     const handleSelect = async (val) => {
//         setValue(val);

//         const placeId = val.value.place_id;

//         // Fetch place details using Place Details API
//         const response = await fetch(
//             `https://maps.googleapis.com/maps/api/place/details/json?placeid=${placeId}&key=AIzaSyDwOFrgNmM51uT1F1zg_L0Em5ujW9obcHk`
//         );
//         const data = await response.json();

//         if (data.result?.geometry) {
//             const address = data.result.formatted_address;
//             const latitude = data.result.geometry.location.lat;
//             const longitude = data.result.geometry.location.lng;
//             onLocationSelect({ latitude, longitude, address });
//         }
//     };

//     return (
//         <div>
//             <GooglePlacesAutocomplete
//                 apiKey="AIzaSyDwOFrgNmM51uT1F1zg_L0Em5ujW9obcHk"
//                 selectProps={{
//                     value,
//                     onChange: handleSelect,
//                     placeholder: 'Enter location...',
//                 }}
//             />
//         </div>
//     );
// };

// export default LocationSearch;


